import { MaskField } from '@octane/spark'
import styled from 'styled-components'

export const FormikMaskedInput = styled(MaskField)`
    &:disabled {
        color: ${(props) => props.theme.colors.monochrome.asphalt};
        background-color: ${(props) => props.theme.colors.monochrome.moonGrey};
        border: none;
    }
`
